module.exports = __webpack_public_path__ + "media/images/icons/favorites_green_s-c0f5391c01ed725b839be59b4140c962.svg";